import { Transacao } from './transacao.model'

export class Antecipacao extends Transacao {
    dataDaAntecipacao: Date
    taxaDaAntecipacao: number
    valorDaAntecipacao: number
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/extrato/antecipacao.model.ts